import { sanitiseVueObservable } from "react-migration/domains/sites/pipeline/helpers/sanitiseVueObservable";
import { skipTracingStore } from "../store";
import { useSnapshot } from "valtio";

export const useSkipTraceValidationError = () => {
  const { validationError } = useSnapshot(skipTracingStore);

  return sanitiseVueObservable(validationError);
};
